import React from 'react';

const Ex2_Data = () => {
    return (
        <div>Ex2_Data Component</div>
    );
}

export default Ex2_Data;
